import { type AvailableCoupon } from '@hooks-api/types/dataModel/coupon'
import { type AppliedCouponCriterionsMap, type MergedCoupon, type MergedCouponMap, type ProductMap } from '../types'

/**
 * Parse availableCoupons and appliedCouponCriterionsMap to MergedCouponMap
 */
export const parseMergedCouponMap = (
  availableCoupons: AvailableCoupon[] | undefined,
  appliedCouponCriterionsMap: AppliedCouponCriterionsMap | undefined,
  productMap: ProductMap | undefined,
): MergedCouponMap | undefined => {
  return availableCoupons?.reduce((prev, curr) => {
    prev.set(curr.coupon_id, {
      ...curr,
      criterions: curr.criterion_groups
        .flatMap(criterionGroup => criterionGroup.criterions)
        .map(criterion => ({
          ...criterion,
          applied_status: null,
          left_quantity: null,
          left_amount: null,
          /**
           * 如果 criterions 是單門檻的用來顯示再湊多少的 UI，因為 calculate 在條件未符合時無法取得剩餘數量，所以需要透過 availableCoupons 的值額外處理
           */
          display_criterion_quantity: curr.criterion_groups.length === 1 && curr.criterion_groups[0]?.criterions.length === 1 ? criterion.criterion_quantity : null,
          ...appliedCouponCriterionsMap?.[curr.coupon_id]?.[criterion.id],
          giveaways: criterion.giveaways.map(product => productMap?.[product.product_id]).filter(product => product !== undefined),
          giveawaysCount: criterion.giveaways.length,
        })) || [],
      couponTypes: new Set(curr.criterion_groups.map(criterionGroup => criterionGroup.type)),
      promotionTypes: new Set(curr.criterion_groups.map(criterionGroup => criterionGroup.promotion_type).filter(promotionType => promotionType !== null)),
      productDeliveryClasses: [...new Set(curr.criterion_groups.flatMap(criterionGroup => criterionGroup.product_delivery_classes ?? []))],
    })
    return prev
  }, new Map<number, MergedCoupon>())
}
